//Klaviyo defines this global variable for sending tracking clientInformation.
var _learnq = window._learnq || [];

// Add to cart for PDP (Product Display Page)
document.querySelectorAll(".template-product form[action*='/cart/add'] button[type='submit']").forEach(button => {
    if (!window.addToCartGlobal) {
        window.addToCartGlobal = addToCart;
    }
    button.addEventListener('click', window.addToCartGlobal);
});

// end add to cart to Klaviyo with the Item information.
async function addToCart(event) {
    const form = new FormData(event.target.form);

    if (!form.get('product-id')) {
        console.log("invalid product-id");
        return;
    };

    if (!window.item) {
        console.log("item does not exist");
        return;
    }

    let addToCartItem = {
        Brand: window.item.Brand,
        Categories: window.item.Categories,
        ImageURL: window.item.ImageURL,
        Name: window.item.Name,
        CompareAtPrice: window.item.CompareAtPrice,
        Price: window.item.Price,
        currency_code: form.get('currency-code'), //Property would be in camelCase, but need it in snake_case
        ProductID: window.item.ProductID,
        URL: window.item.URL,
        Origin: 'PDP'
    }

    //if you want the klaviyo default properties, specified in the snippet, to be included
    const useKlaviyoDefaultCartProperties = true;

    if (useKlaviyoDefaultCartProperties) {
        try {
            const res = await fetch(`${window.location.origin}/cart.js`);
            const data = await res.clone().json();

            //create cart with default properties given in klaviyo snippet
            //data from the cart before the current product was added
            const cart = {
                total_price: data.total_price/100,
                $value: data.total_price/100,
                total_discount: data.total_discount,
                original_total_price: data.original_total_price/100,
                items: data.items,
            }

            addToCartItem = Object.assign(addToCartItem, cart);
        } 
        catch(error) {
            console.log("Error fetching from cart.js ", error);
        }
    }

    _learnq.push(['track', 'Added to Cart', addToCartItem]);
};